import { outreach } from '@round/api';

export type OutreachResultsEmptyStateVariant = 'error' | 'noneFound' | 'collecting' | 'noMatches';

type VariantParams = {
    status: outreach.OutreachStatus;
    /** Every result the request has found, whatever the tab on screen is showing. */
    resultsCount: number;
    /** A location filter, or a tab narrower than "all". */
    hasFilters: boolean;
    isError: boolean;
};

/** Nothing more is coming for a cancelled request either, so it reads the same as a complete one. */
const FINISHED_STATUSES: outreach.OutreachStatus[] = ['complete', 'cancelled'];

export function getEmptyStateVariant({
    status,
    resultsCount,
    hasFilters,
    isError,
}: VariantParams): OutreachResultsEmptyStateVariant {
    if (isError) {
        return 'error';
    }

    // With no results found at all, neither the tab nor the filter can be why the table is empty.
    if (hasFilters && resultsCount > 0) {
        return 'noMatches';
    }

    return FINISHED_STATUSES.includes(status) ? 'noneFound' : 'collecting';
}
